module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/znamenka-a-kozni-vyrustky_3_after.jpg
// module id = 1009
// module chunks = 0